import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControlBase } from '../../../form-models/form-control-base';
import { DynamicFormControlViewsService } from '../dynamic-form-control-views/dynamic-form-control-views.service';

@Component({
  selector: 'hb-df-control-label',
  templateUrl: './dynamic-form-control-label.component.html',
  styleUrls: ['./dynamic-form-control-label.component.scss'],
})
export class DynamicFormControlLabelComponent {
  @Input() control: FormControlBase<any>;
  @Input() required: boolean = false;
  @Output() onOverrideValue: EventEmitter<any> = new EventEmitter<any>();

  private buttonSize = 16;
  public actionButtonIconStylesWithAnimation: any = {
    fontSize: `${this.buttonSize}px`,
    animation: 'fa-spin 2s infinite linear',
  };

  public actionButtonIconStyles: any = {
    fontSize: `${this.buttonSize}px`,
  };

  public actionButtonStyles = {
    width: `${this.buttonSize}px`,
    height: `${this.buttonSize}px`,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginLeft: '8px',
    outline: 'none',
    border: 'none',
    boxShadow: 'none',
  };

  constructor(public dynamicFormControlViewsService: DynamicFormControlViewsService) {}

  public overrideValue(): void {
    this.onOverrideValue.emit();
  }

  public isRequired(): boolean {
    return this.dynamicFormControlViewsService.isRequired(this.control);
  }
}
